import { createFileRoute } from "@tanstack/react-router";
import { MapPin, Calendar } from "lucide-react";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { clientForPortalUser, portalDataForClient } from "@/mocks/saas-data";

export const Route = createFileRoute("/portal/shoots")({
  ssr: false,
  head: () => ({ meta: [{ title: "Portal — Shoots" }] }),
  component: Page,
});

function Page() {
  const user = useRequireRole(["client_portal"]);
  if (!user) return null;
  const client = clientForPortalUser(user.id);
  const shoots = client ? portalDataForClient(client.name).shoots : [];

  return (
    <div className="mx-auto max-w-5xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Your shoots" description="Everything booked, in progress, and wrapped." />
      <div className="space-y-3">
        {shoots.map((s) => (
          <div key={s.id} className="rounded-xl bg-card p-5 ring-1 ring-border">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <h3 className="text-lg font-medium">{s.title}</h3>
                <p className="mt-1 flex items-center gap-3 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1.5"><Calendar className="size-3" /> {s.date} · {s.callTime}</span>
                  <span className="flex items-center gap-1.5"><MapPin className="size-3" /> {s.location}</span>
                </p>
                {s.notes && <p className="mt-3 text-sm text-foreground/80">{s.notes}</p>}
              </div>
              <StatusBadge status={s.status} />
            </div>
            <div className="mt-4 grid grid-cols-3 gap-3 border-t border-border pt-4 text-xs">
              <div><span className="font-mono uppercase text-muted-foreground">Duration</span><p className="mt-0.5 font-medium">{s.duration}</p></div>
              <div><span className="font-mono uppercase text-muted-foreground">Call time</span><p className="mt-0.5 font-medium">{s.callTime}</p></div>
              <div><span className="font-mono uppercase text-muted-foreground">Status</span><p className="mt-0.5 font-medium capitalize">{s.status}</p></div>
            </div>
          </div>
        ))}
        {shoots.length === 0 && (
          <p className="rounded-xl bg-card p-10 text-center text-sm text-muted-foreground ring-1 ring-border">
            No shoots yet. Your studio will add them here.
          </p>
        )}
      </div>
    </div>
  );
}
